import { render, staticRenderFns } from "./EditItemDialog.vue?vue&type=template&id=60fe4246&scoped=true&"
import script from "./EditItemDialog.vue?vue&type=script&lang=js&"
export * from "./EditItemDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditItemDialog.vue?vue&type=style&index=0&id=60fe4246&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fe4246",
  null
  
)

export default component.exports